module.exports = __webpack_public_path__ + "img/2-1.326c85f.png";